import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadMe = useCallback(async () => {
    const token = localStorage.getItem("scc_token");
    if (!token) { setUser(false); setLoading(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("scc_token");
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { loadMe(); }, [loadMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("scc_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const loginGoogle = async (session_id) => {
    const { data } = await api.post("/auth/google", { session_id });
    localStorage.setItem("scc_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("scc_token");
    setUser(false);
    window.location.href = "/login";
  };

  const can = (...roles) => user && (user.role === "owner" || roles.includes(user.role));

  return (
    <AuthCtx.Provider value={{ user, loading, login, loginGoogle, logout, can }}>
      {children}
    </AuthCtx.Provider>
  );
}
